import { Box, Typography, useTheme } from "@mui/material";
import { sxStyles } from "./BannerSection.styles";
import IMAGES from "lib/assets/images";
import { navigateToExternalInMobileBrowser } from "lib/routing/navigate/navigate";

// Constants
export const BANNER_BODY = `Stay healthy with Health Together, a community initiative by NUHS and its partners in western Singapore. Receive personalised health and wellness tips, invitations to events and health screenings, and access to self-help tools, programmes and resources near you.`;
const SIGN_UP_URL = "https://for.sg/nuhsapp-ht-signup";

const BannerSection = () => {
  const theme = useTheme();
  const classes = sxStyles(theme);

  const handleOnClickSignUp = () => {
    navigateToExternalInMobileBrowser(SIGN_UP_URL);
  };

  return (
    <Box>
      <Box
        component="img"
        sx={classes.image}
        src={IMAGES.healthTogetherMHM.HTLandingBannerImage}
        alt="Health Together page banner"
      />

      <Typography sx={classes.bannerTextBody}>
        {BANNER_BODY}
        <br />
        <br />
        {`Sign up for Health Together `}
        <Typography
          component="span"
          sx={classes.link}
          onClick={handleOnClickSignUp}
        >
          here
        </Typography>
        !
      </Typography>
    </Box>
  );
};

export default BannerSection;
